import { ICreateVerbaPagamentoUseCase } from "../../../presentation/useCases/create/create_verba_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateVerbaPagamentoUseCase
 */

export class CreateVerbaPagamentoUseCase implements ICreateVerbaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createVerbaPagamento(
    ativo: boolean,
    tipo: number,
    nro: string | null,
    verba: string,
    valor: number | null,
  ): Promise<void> {
    await this.repository.createVerbaPagamento(
      ativo,
      tipo,
      nro,
      verba,
      valor,
    );
  }
}
